import Image from 'next/image';

import Link from '@/components/link';
import Badge from '@/components/blog/badge';
import { truncateText } from '@/utils/resolvers';
import CardCTALink from '@/components/blog/card-cta-link';
import Button from '@/components/Button';
import { SuccessStoryCardFragment } from '@/generated/graphcms-schema';

export default function FeaturedPost({
  coverImage,
  slug,
  subTitle,
  title,
}: Partial<SuccessStoryCardFragment>) {
  return (
    <section className="flex flex-col items-center justify-between md:flex-row">
      <div className="blog-image w-full">
        <Link href={`/case-studies/${slug}`} className="blog-card-image">
          {coverImage?.url && (
            <Image
              width={740}
              height={422}
              src={coverImage.url}
              alt={coverImage.alt || ``}
              className="rounded"
              objectFit="cover"
              layout="responsive"
              priority
            />
          )}
        </Link>
      </div>

      <div className="blog-card-text mt-4 w-full sm:flex-col md:ml-10 md:mt-0 md:max-w-sm lg:ml-20">
        <div className="mb-4">
          <Badge as="text" title="Featured" variant="primary" />
        </div>
        <Link
          href={`/case-studies/${slug}`}
          className="blog-card-title space-y-4 transition-colors hover:text-cornflower"
        >
          <h2 className="text-[22px] font-bold leading-tight md:text-3xl">
            {title}
          </h2>
          <p className="leading-normal text-light-haiti">
            {truncateText({ text: subTitle || `` })}
          </p>
          <Button withArrow colour="purple" className="hidden md:flex">
            Learn more
          </Button>
        </Link>
        <div className="mt-8 flex items-center justify-end">
          <CardCTALink
            href={`/case-studies/${slug}`}
            className="flex-shrink-0 lg:hidden"
            text="Learn more"
          />
        </div>
      </div>
    </section>
  );
}
